import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import UpgradeImage from "assets/images/upgrade-image.svg";
import styled from "styled-components";
import Backdrop from "./Backdrop";
import ModalWrapper from "./ModalWrapper";
import Spacer from "./Spacer";
import Button from "./Button";

const Wrapper = styled(Backdrop)`
  backdrop-filter: blur(10px);
  z-index: ${({ cover }) => (cover ? "12" : "11")};

  .card {
    background-color: #fff;
    width: 480px;
    padding: 24px;
    border-radius: 16px;
  }

  .image {
    width: 100%;
  }

  .title {
    font-size: 18px;
    font-weight: 700;
  }

  .description {
    font-size: 16px;
    line-height: 24px;
  }

  .actionBtns {
    gap: 24px;
  }

  .btn {
    height: 48px;
    width: 100%;
    border-radius: 8px;
    padding: 0 24px;
    text-transform: capitalize;
  }

  @media screen and (max-width: 768px) {
    .card {
      width: calc(100% - 24px);
      padding: 24px;

      .title {
        font-size: 16px;
      }

      .description {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
`;

const UpgradeModal = ({
  collection,
  modalTitle,
  modalDescription,
  current_sub,
  handleCancel,
  actionOnly,
  cover,
  showModal,
}) => {
  const router = useHistory();
  const planName = current_sub?.plan_name;

  const upgradeModalTitle = "Upgrade your account";

  const upgradeModalDescription = {
    posts:
      "You have used up the maximum number of posts for this plan. Upgrade your plan to create more posts.",
    brands:
      planName === "Agency"
        ? "You've reached the limit of available brand slots. To add more brands, simply purchase additional slots."
        : "You have reached the maximum number of brands for this plan. Upgrade your plan to add more brands.",
    team:
      planName === "Agency"
        ? "You've used up all your team member slots. Don't worry, you can expand your team by adding more members to ensure smooth collaboration."
        : "This plan only allows one team member. Upgrade your plan to add more team members.",
    comments:
      "Engage with all your followers right from PostPaddy. Upgrade your plan gain access.",
    private_messages:
      "Take charge of your social media by replying to all your private messages on PostPaddy. Upgrade your plan gain access.",
    account_analytics:
      "Gain valuable insights into your account activities right on PostPaddy. Upgrade your plan gain access.",
    content_analytics:
      "See all your post engagements directly on PostPaddy. Upgrade your plan gain access.",
    audience_analytics:
      "Gain insights into the demographics of your audience. Upgrade your plan gain access.",
  };

  const upgradeModalActionText =
    planName === "Agency" && collection === "brands"
      ? "Add brands"
      : planName === "Agency" && collection === "team"
      ? "Add users"
      : "Upgrade";

  return (
    <Wrapper
      className={`flexRow justifyEnd ${showModal && "show"}`}
      cover={cover}
    >
      <ModalWrapper>
        <div className="card flexColumn alignCenter">
          <img src={UpgradeImage} alt="." className="image" />
          <Spacer y={2.4} />
          <h5 className="colorGrey1 textCenter title">
            {modalTitle || upgradeModalTitle}
          </h5>
          <Spacer y={0.6} />
          <p className="colorBodyText textCenter description">
            {modalDescription || upgradeModalDescription[collection]}
          </p>
          <Spacer y={2.4} />
          <div className="flexRow justifyCenter fullWidth actionBtns">
            {!actionOnly && (
              <Button
                text={"Cancel"}
                className="btn flexRow alignCenter justifyCenter"
                color="var(--grey_1)"
                bd="var(--grey_10)"
                bg="#fffff"
                onClick={() => {
                  handleCancel();
                }}
              />
            )}
            <Button
              text={upgradeModalActionText}
              className="btn secondary"
              bg="var(--secondary)"
              fullWidth
              color="#fff"
              onClick={() => router.push("/dashboard/plans")}
            />
          </div>
        </div>
      </ModalWrapper>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    current_sub: state.current_sub,
  };
};

export default connect(mapStateToProps)(UpgradeModal);
